module.exports = "./../fonts/roboto-v30-latin-500italic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-v30-latin-500italic.woff
// module id = 51
// module chunks = 0